import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface DialogData {
  reportURL: string;
}

@Component({
  selector: 'app-report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss'],
})
export class ReportViewerComponent implements OnInit {
  source!: SafeResourceUrl;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.source = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.data.reportURL
    );
  }
}
